export const CALL = 'CALL';
export const EMAIL = 'EMAIL';
export const TODO = 'TODO';
export const LINKED_IN = 'LINKED_IN';
export const LINKED_IN_CONNECT = 'LINKED_IN_CONNECT';
export const LINKED_IN_MESSAGE = 'LINKED_IN_MESSAGE';